<template>
    <div>
        <div
            class="flex min-w-0 items-center gap-2 border-l-4 p-3 font-medium"
            :class="{
                'border-danger-600 bg-danger-100 text-danger-700': isDanger,
                'border-warning-600 bg-warning-100 text-warning-700': isWarning
            }"
        >
            <i
                v-if="isDanger || isWarning"
                class="pi pi-exclamation-triangle"
            />
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    theme?: 'danger' | 'warning'
}>()

const isDanger = computed(() => {
    return props.theme === 'danger'
})

const isWarning = computed(() => {
    return props.theme === 'warning'
})
</script>
